import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Navbar from './components/Navbar';
import Glossar from './pages/Glossar';

import Home from './pages/Home';

import Notation from './pages/Notation';
import NotationLernfeld1 from './pages/NotationLernfeld1';
import NotationLernfeld2 from './pages/NotationLernfeld2';
import NotationLernfeld3 from './pages/NotationLernfeld3';
import NotationLernfeld4 from './pages/NotationLernfeld4';
import NotationLernfeld5 from './pages/NotationLernfeld5';  

import Instrumente from './pages/Instrumente';
import InstrumenteLernfeld1 from './pages/InstrumenteLernfeld1';
import InstrumenteLernfeld2 from './pages/InstrumenteLernfeld2';
import InstrumenteLernfeld3 from './pages/InstrumenteLernfeld3';
import InstrumenteLernfeld4 from './pages/InstrumenteLernfeld4';
import InstrumenteLernfeld5 from './pages/InstrumenteLernfeld5';

import Formen from './pages/Formen';
import FormenLernfeld1 from './pages/FormenLernfeld1';
import FormenLernfeld2 from './pages/FormenLernfeld2';
import FormenLernfeld3 from './pages/FormenLernfeld3';
import FormenLernfeld4 from './pages/FormenLernfeld4';
import FormenLernfeld5 from './pages/FormenLernfeld5';

import Gestaltungsprinzipien from './pages/Gestaltungsprinzipien';
import GestaltungsprinzipienLernfeld1 from './pages/GestaltungsprinzipienLernfeld1';
import GestaltungsprinzipienLernfeld2 from './pages/GestaltungsprinzipienLernfeld2';
import GestaltungsprinzipienLernfeld3 from './pages/GestaltungsprinzipienLernfeld3';
import GestaltungsprinzipienLernfeld4 from './pages/GestaltungsprinzipienLernfeld4';
import GestaltungsprinzipienLernfeld5 from './pages/GestaltungsprinzipienLernfeld5';

import Komponisten from './pages/Komponisten';
import KomponistenLernfeld1 from './pages/KomponistenLernfeld1';
import KomponistenLernfeld2 from './pages/KomponistenLernfeld2';
import KomponistenLernfeld3 from './pages/KomponistenLernfeld3';
import KomponistenLernfeld4 from './pages/KomponistenLernfeld4';
import KomponistenLernfeld5 from './pages/KomponistenLernfeld5';

import Quiz from './pages/Quiz';
import Summary from './pages/Summary';

import './index.css';


function App() {
  return (
    <Router>
      {/* Navigation bleibt immer sichtbar */}
      <header className="site-header">
        <Navbar />
      </header>

      {/* Hauptinhalte / Views */}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/glossar" element={<Glossar />} />
        <Route path="/" element={<Home />} />

        <Route path="/notation" element={<Notation />} />
         <Route path="/notationlernfeld1" element={<NotationLernfeld1 />} />
          <Route path="/notationlernfeld2" element={<NotationLernfeld2 />} />
          <Route path="/notationlernfeld3" element={<NotationLernfeld3 />} />
          <Route path="/notationlernfeld4" element={<NotationLernfeld4 />} />
          <Route path="/notationlernfeld5" element={<NotationLernfeld5 />} />

        <Route path="/instrumente" element={<Instrumente />} />
        <Route path="/instrumentelernfeld1" element={<InstrumenteLernfeld1 />} />
        <Route path="/instrumentelernfeld2" element={<InstrumenteLernfeld2 />} />
        <Route path="/instrumentelernfeld3" element={<InstrumenteLernfeld3 />} />
        <Route path="/instrumentelernfeld4" element={<InstrumenteLernfeld4 />} />
        <Route path="/instrumentelernfeld5" element={<InstrumenteLernfeld5 />} />

        <Route path="/formen" element={<Formen />} />
        <Route path="/formenlernfeld1" element={<FormenLernfeld1 />} />
        <Route path="/formenlernfeld2" element={<FormenLernfeld2 />} />
        <Route path="/formenlernfeld3" element={<FormenLernfeld3 />} />
        <Route path="/formenlernfeld4" element={<FormenLernfeld4 />} />
        <Route path="/formenlernfeld5" element={<FormenLernfeld5 />} />

        <Route path="/gestaltungsprinzipien" element={<Gestaltungsprinzipien />} />
        <Route path="/gestaltungsprinzipienlernfeld1" element={<GestaltungsprinzipienLernfeld1 />} />
        <Route path="/gestaltungsprinzipienlernfeld2" element={<GestaltungsprinzipienLernfeld2 />} />
        <Route path="/gestaltungsprinzipienlernfeld3" element={<GestaltungsprinzipienLernfeld3 />} />
        <Route path="/gestaltungsprinzipienlernfeld4" element={<GestaltungsprinzipienLernfeld4 />} />
        <Route path="/gestaltungsprinzipienlernfeld5" element={<GestaltungsprinzipienLernfeld5 />} />

        <Route path="/komponisten" element={<Komponisten />} />
        <Route path="/komponistenlernfeld1" element={<KomponistenLernfeld1 />} />
        <Route path="/komponistenlernfeld2" element={<KomponistenLernfeld2 />} />
        <Route path="/komponistenlernfeld3" element={<KomponistenLernfeld3 />} />
        <Route path="/komponistenlernfeld4" element={<KomponistenLernfeld4 />} />
        <Route path="/komponistenlernfeld5" element={<KomponistenLernfeld5 />} />

        <Route path="/quiz" element={<Quiz />} />
        <Route path="/summary" element={<Summary />} />
       
      </Routes>
    </Router>
  );
}

export default App;